import circleLog from '../assets/logo-3.png';
const Details={
    "url":localStorage.getItem("domain"),
    "circlelogo":circleLog,
    "blueColor":"#958f88",
    "mustard":"#bfec99",
    "garland":"#bfec99",
    "bottomNav":"#bfec99"
}
export default Details;